import { render, staticRenderFns } from "./NewsAdminEdit.vue?vue&type=template&id=8029c048"
import script from "./NewsAdminEdit.vue?vue&type=script&lang=js"
export * from "./NewsAdminEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports